<template>
  <div class="container" v-if="loading">
    <section class="py-5" id="about">
      <div v-if="project" class="container mb-5">
        <div class="container text-center">
          <div class="row">
            <div class="col-lg-10 mx-auto">
              <h1>{{ project.title }}</h1>
              <p v-if="getCurrentLang() == 'en'" class="lead">{{ project.tldr_en }}</p>
              <p v-else class="lead">{{ project.tldr_en }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="row">
      <!-- Carousel -->
      <div class="col-md-8 w-100">
        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators">
            <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
            <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
            <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
            <li v-if="project.video != null" data-target="#carouselExampleIndicators" data-slide-to="3"></li>
          </ol>
          <div class="carousel-inner w-100">
            <div v-if="project.video != null" class="carousel-item active">
              <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" :src="project.video" frameborder="0" allowfullscreen></iframe>
              </div>
            </div>
            <div class="carousel-item" :class="classe">
              <img class="d-block w-100" v-bind:src="images[0]" alt="Second slide">
            </div>
            <div class="carousel-item">
              <img class="d-block w-100" v-bind:src="images[1]" alt="Third slide">
            </div>
            <div class="carousel-item">
              <img class="d-block w-100" v-bind:src="images[2]" alt="Fourth slide">
            </div>
            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>

      <!-- Users -->
      <div class="col-md-4 mr-0 mt-4 mt-md-0">
        <section class="" id="about">
          <div class="container">
            <div class="row">
              <div class="col-lg-10 mx-auto">
                <h3>Team</h3>
              </div>
            </div>
          </div>
        </section>
        <ul class="list-group list-group-flush">
          <li v-for="user in users" class="list-group-item">{{ user.name }}</li>
        </ul>
      </div>
    </div>

    <hr>

    <div class="row">
      <div class="col-md-8 w-100">
        <!-- Description -->
        <div class="container w-100">
          <div v-if="getCurrentLang() == 'en'" class="mt-4 textall w-100" v-html="project.description_en">{{ project.description }}</div>
          <div v-else class="mt-4 textall w-100" v-html="project.description">{{ project.description }}</div>
        </div>
      </div>

      <!-- Description -->
      <div class="col-md-4 mt-5">
        <pie-chart :donut="true" :data="chartData" legend="bottom" :colors="['#2ecc71', '#3498db', '#e74c3c', '#f1c40f', '#34495e']"></pie-chart>
      </div>
    </div>

    <hr v-if="project.affiliati[0] != ''">

    <div class="row mt-5" v-if="project.affiliati[0] != ''">
      <div class="col-lg-8 mx-auto text-center">
        <h2 class="large">{{$t("m_affiliates_title")}}</h2>
        <p class="text-muted">{{$t("m_affiliates_description")}}</p>
      </div>
    </div>
    <section class="py-5">
      <div class="container">
        <div class="row justify-content-center">

          <div v-if="project.affiliati[0] != ''" v-for="affiliato in project.affiliati" class="col-sm-4 ">

            <div class="card text-white bg-info mb-3 " style="max-width: 18rem;">
              <div class="card-header text-center">{{affiliato}}</div>

            </div>

          </div>

        </div>
      </div>
    </section>

    <!-- Clients -->
    <hr>
    <div class="row mt-5">
      <div class="col-lg-8 mx-auto text-center">
        <h2 class="large">{{$t("m_patrons_title")}}</h2>
        <p class="text-muted">{{$t("m_patrons_description")}}</p>

      </div>
    </div>

    <section class="py-5">
      <div class="container">
        <div class="row justify-content-center">

          <div class="col-md-3 col-sm-6 align-middle  my-auto ">
            <img class="img-fluid d-block mx-auto" src="../assets/microsoft.png" style="filter: grayscale(100%);" alt="">
          </div>
          <div class="col-md-3 col-sm-6 align-middle my-auto">
            <img class="img-fluid d-block  mx-auto" src="../assets/ibm.png" style="filter: grayscale(100%);" alt="">
          </div>

        </div>
      </div>
    </section>

    <hr>
    <div class="row mt-5">
      <div class="col-lg-8 mx-auto text-center">
        <h2 class="large">{{$t("m_courses")}}</h2>

      </div>
    </div>

    <div class="container" v-if="courses.length > 0">
      <div class="row">
        <div v-for="course in courses" class="col-md-3 card text-center m-3 p-3">
          <div class="brick__inner" style="border-radius:10px; height:100%; margin-top:3px;">
            <img :src="course.image" alt="" class="img-fluid" style="border-radius:10px;"></img>
            <div class="card-body">
              <h5 class="card-title">{{ course.title }}</h5>
              <p v-if="getCurrentLang() == 'en'" class="card-text">{{ course.tldr_en }}</p>
              <p v-else class="card-text">{{ course.tldr }}</p>
              <!--<router-link class="btn btn-outline-primary" :to="{ name: 'CourseDetail', params: { id: course.id }}">Dettagli</router-link>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div v-for="course in courses" class="col-md-4 mb-3">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title texto">{{ course.title }}</h5>
                <h6 class="card-subtitle mb-2 text-muted" v-if="course.teacher">{{ course.teacher }}</h6>
                <h6 class="card-subtitle mb-2 text-muted" v-else>Nessun insegnante registrato</h6>
              </div>
            </div>
          </div> -->
  <div class="d-flex justify-content-center mt-5" v-else>
    <div class="loader"></div>
  </div>
</template>

<script>
import { database, storage } from '@/firebase';
import i18n from '../i18n';

export default {
  name: 'ProjectDetail',
  data() {
    return {
      chartData: null,
      project: null,
      users: [],
      courses: [],
      images: [],
      user: null,
      loading: false,
      classe: ''
    };
  },
  methods: {
    getCurrentLang: function() {
      var chosen = localStorage.getItem('choose_lang');
      var current_locale;

      if (chosen != null) {
        chosen = localStorage.getItem('choose_lang');
        console.log(chosen);
        current_locale = chosen;
      } else {
        console.log(navigator.language);
        current_locale = 'en';

        if (navigator.language.includes('it')) {
          current_locale = 'it';
        }
      }
      return current_locale
    }
  },
  created() {
    if (this.$route.params.id == '74loBjYvwikrLo8xg1hh') {
      this.chartData = [
        [i18n.getLocaleMessage(this.getCurrentLang()).m_legend_formation, 85],
        [i18n.getLocaleMessage(this.getCurrentLang()).m_legend_advice, 10],
        [i18n.getLocaleMessage(this.getCurrentLang()).m_legend_materials, 0],
        [i18n.getLocaleMessage(this.getCurrentLang()).m_legend_other, 5]
      ];
    } else if (this.$route.params.id == 'DogtSHbrvfc9EldqNoyJ') {
      this.chartData = [
        [i18n.getLocaleMessage(this.getCurrentLang()).m_legend_formation, 5],
        [i18n.getLocaleMessage(this.getCurrentLang()).m_legend_advice, 20],
        [i18n.getLocaleMessage(this.getCurrentLang()).m_legend_materials, 75],
        [i18n.getLocaleMessage(this.getCurrentLang()).m_legend_other, 0]
      ];
    } else {
      this.chartData = [
        [i18n.getLocaleMessage(this.getCurrentLang()).m_legend_formation, 25],
        [i18n.getLocaleMessage(this.getCurrentLang()).m_legend_advice, 10],
        [i18n.getLocaleMessage(this.getCurrentLang()).m_legend_materials, 60],
        [i18n.getLocaleMessage(this.getCurrentLang()).m_legend_other, 5]
      ];
    }
    database
      .collection('Projects')
      .doc(this.$route.params.id)
      .get()
      .then(projectDoc => {
        this.project = projectDoc.data();
        if (this.project.video == undefined) {
          this.project.video = null;
          this.classe = 'active';
        }
        this.project.team.get().then(teamDoc => {
          let users = teamDoc.data().users;
          users.forEach(user => {
            user.get().then(userDoc => {
              this.users.push(userDoc.data());
            });
          });
          teamDoc.data().courses.forEach(course => {
            course.get().then(courseDoc => {
              var course = courseDoc.data();
              course.id = courseDoc.id;
              course.teacher.get().then(teacherDoc => {
                course.teacher = teacherDoc.data();
              });
              storage
                .child('Courses/' + courseDoc.id + '/profile')
                .getDownloadURL()
                .then(resolve => {
                  course.image = resolve;
                  this.loading = true;
                  this.courses.push(course);
                });
            });
          });
        });
      });

    for (let i = 1; i <= 3; i++) {
      storage
        .child(
          'Projects/' +
            this.$route.params.id +
            '/Slideshow/' +
            (i - 1).toString()
        )
        .getDownloadURL()
        .then(url => {
          this.images.push(url);
        });
    }
  }
};
</script>

<style scoped>
.card {
  width: 18rem;
  padding: 0px;
}
.imgcard {
  width: 100%;
}
.ql-video {
  width: 500px;
  height: 250px;
}
.textall {
  color: #303030;
  font-size: 18px;
}

.texto {
  color: #f0932b;
}

.titler {
  color: #f0932b;
  font-weight: bold;
}

.buttora {
  color: rgb(71, 71, 71);
  background-color: #f0932b;
}
body {
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: 'Lato', sans-serif;
  letter-spacing: 0px;
  font-size: 16px;
  color: #62686c;
  font-weight: 400;
  line-height: 28px;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 300;
  color: #11181f;
  margin: 0px 0px 15px 0px;
  font-family: 'Lato', sans-serif;
}
h1 {
  font-size: 44px;
}
h2 {
  font-size: 38px;
}
h3 {
  font-size: 24px;
  font-weight: 400;
}
h4 {
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
}
h5 {
  font-size: 16px;
  font-weight: 400;
}
h6 {
  font-size: 12px;
  font-weight: 400;
}
p {
  margin: 0 0 20px;
  line-height: 1.7;
}
p:last-child {
  margin: 0px;
}
a {
  text-decoration: none;
  color: #62686c;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}
a:focus,
a:hover {
  text-decoration: none;
  color: #f67800;
}

.content {
  padding-top: 80px;
  padding-bottom: 80px;
}
.mb40 {
  margin-bottom: 40px;
}
.team-block {
  margin-bottom: 20px;
}
.team-content {
  position: absolute;
  background-color: rgba(17, 24, 31, 0.8);
  bottom: 0px;
  display: inline-block;
  width: 100%;
  color: #fff;
  padding: 30px;
}
.team-img {
  position: relative;
}
.team-img img {
  width: 100%;
}
.team-meta {
  color: #9da4aa;
  font-weight: 400;
  font-size: 16px;
}
.overlay {
  border-radius: 0px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
  background-color: #11181f;
}
.team-img:hover .overlay {
  opacity: 0.8;
}
.team-img:hover .team-content {
  opacity: 0;
}
.text {
  color: #fff;
  position: absolute;
  top: 30%;
  left: 30%;
  transform: translate(-26%, -26%);
  -webkit-transform: translate(-26%, -26%);
  -moz-transform: translate(-26%, -26%);
  right: 0;
  font-weight: 400;
  font-size: 16px;
}
.text .btn.btn-outline-primary {
  color: white;
}
.loader {
  border: 4px solid #f3f3f3;
  border-radius: 100%;
  border-top: 4px solid #46484c;
  width: 60px;
  height: 60px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 0.5s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectDetail.vue